import Appsignal from "@appsignal/javascript"
import { plugin } from "@appsignal/plugin-breadcrumbs-network"

export let appsignal: Appsignal

if (process.client) {
  appsignal = new Appsignal({
    key: import.meta.env.VITE_APPSIGNAL_KEY,
    revision: import.meta.env.VITE_COMMIT_SHA
  })
  appsignal.use(plugin())
}
